export default (props, vars) => !props?.['hideCloseButton'];
